export default __webpack_public_path__ + "static/media/1658.dc865012.png";